
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M9.872 2.83a.75.75 0 011.06 0l2.866 2.866a.75.75 0 010 1.06L6.395 14.16a.75.75 0 01-1.06 0l-2.866-2.865a.75.75 0 010-1.06L9.872 2.83zm.53 1.592L4.06 10.764l1.805 1.805 6.342-6.342-1.805-1.805z","fill":"#8F7A61"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M3.013 10.034a.75.75 0 01.75.75v2.102h2.073a.75.75 0 010 1.5H3.013a.75.75 0 01-.75-.75v-2.852a.75.75 0 01.75-.75zM8.404 4.304a.75.75 0 011.06-.002l2.874 2.867A.75.75 0 1111.28 8.23L8.405 5.364a.75.75 0 010-1.06z","fill":"#8F7A61"}})])
          )
        }
      }
    